import { render, staticRenderFns } from "./ItemDetailUtility.vue?vue&type=template&id=18468e8c&scoped=true&"
import script from "./ItemDetailUtility.vue?vue&type=script&lang=js&"
export * from "./ItemDetailUtility.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18468e8c",
  null
  
)

export default component.exports